import { get } from 'common/utils/request';
export var fetchProfileBalanceAndNotificationsMetaApi = function (checkNewNotificationsFrom) {
    return get("/employees/self/polling".concat(checkNewNotificationsFrom ? "?checkNewNotificationsFrom=".concat(checkNewNotificationsFrom) : ''));
};
